import { WorkflowState } from './workflow.model';

export interface Notification {
  workflowContext: WorkflowState;
  type: NotificationType;
  dynamicTemplate?: {
    [key: string]: LocaleDynamicTemplate;
  } | null;
  staticTemplate?: {
    [key: string]: LocaleStaticTemplate;
  } | null;
}

export interface LocaleStaticTemplate {
  title: string | null;
  subject: string;
  emailBody?: string;
  emailMessage?: string;
  smsBody?: string;
}

export interface LocaleDynamicTemplate {
  emailTemplateName?: string;
  smsTemplateName?: string;
}

export enum NotificationType {
  STATIC = 'STATIC',
  NOTIFICATION_ENGINE_TEMPLATE = 'NOTIFICATION_ENGINE_TEMPLATE',
}

export type NotificationTemplateType =
  | 'SERVICE'
  | 'ORGANIZATION_SERVICE'
  | 'PLATFORM';

export type NotificationTemplateStatus = 'Active' | 'Deactivated';

export interface NotificationTemplate {
  id?: string;
  templateId?: string;
  type: 'EMAIL' | 'SMS';
  subject?: string;
  language: string;
  templateName: string;
  template: string;
  status?: string;
  organizationId?: string;
  templateType?: NotificationTemplateType;
  stringifiedTemplate?: string;
}

export interface NotificationTemplateMutationResponse {
  message: string;
}

export interface NotificationPreviewData {
  [locale: string]: {
    title: string;
    message: string;
  };
}

export interface ServiceNotificationTemplates {
  templates: NotificationTemplate[];
  totalTemplates: number;
  totalPages: number;
}
